import React, { useState } from 'react';
import Customers from '../../admincomponents/Customers/Customers';
import { FiMenu, FiX } from 'react-icons/fi';
import AdmVertNav from '../../admincomponents/AdminVertNav/AdmVertNav';

const Siteusers = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className='products-admin-container'>
      {/* Mobile Navigation Toggle */}
      <button 
        className="products-mobile-nav-toggle"
        onClick={() => setMobileNavOpen(!mobileNavOpen)}
      >
        {mobileNavOpen ? <FiX size={24} /> : <FiMenu size={24} />}
      </button>

      {/* Imported Vertical Navigation */}
      <AdmVertNav 
        mobileNavOpen={mobileNavOpen} 
        closeMobileNav={() => setMobileNavOpen(false)} 
      />

      {/* Main Content Area */}
      <div className="products-admin-main-content">
        <div className="products-content-header">
          <h1>ShreeOhm Customers</h1>
          <div className="products-breadcrumb">Admin / Customers</div>
        </div>
        <div className="products-content-body">
          <Customers />
        </div>
      </div>
    </div>
  );
}

export default Siteusers